(function ($, Modernizr) {

    window.init_accounts_find = function() {
        var find = {};


        find.player_render = function () {
            var $item = $(this);
            var playerIconPath;
            var platformIconPath;

            var PLAYER_ICON_SELECTOR = '[data-field="player-icon"] span';
            var PLATFORM_ICON_SELECTOR = '[data-field="platform-icon"] span';

            var $playerIcon = $item.find(PLAYER_ICON_SELECTOR).first();
            var $platformIcon = $item.find(PLATFORM_ICON_SELECTOR).first();

            playerIconPath = 'portal/img/svg-icons/clans/' + (($item.data('me') == "True") ? 'me' : 'player') + '.svg';
            platformIconPath = 'portal/img/svg-icons/platform/positive/' + $item.data('platform') + '.svg';

            $playerIcon.renderListBoxIcon(STATIC_URL + playerIconPath, gettext('Regiment'), 'js-svg-autosize-from-height');
            $platformIcon.renderListBoxIcon(STATIC_URL + platformIconPath, gettext('Platform'), 'svg-icon__platform-positive js-svg-autosize-from-height');
        };

        init_autocomplete = function() {
            var SEARCH_INPUT_SELECTOR = '.js-search-input';
            var SEARCH_BUTTON_SELECTOR = '.js-search-button';
            var AUTOCOMPLETE_VIEW_ALL_SELECTOR = '.js-autocomplete_view-all';
            var AUTOCOMPLETE_WRAPPER_SELECTOR = '.js-autocomplete-wrapper';
            var autocompleteObj;
            autocompleteObj = window.player_autocomplete.activateAutocomplete({
                searchInputSelector: SEARCH_INPUT_SELECTOR,
                autocompleteViewAllSelector: AUTOCOMPLETE_VIEW_ALL_SELECTOR,
                autocompleteWrapperSelector: AUTOCOMPLETE_WRAPPER_SELECTOR,
                submitHandler: function () {
                    $(SEARCH_BUTTON_SELECTOR).focus();
                    autocompleteObj.preventAutocomplete();
                    return true;
                },
            });
        };

        init_autocomplete();
        window.find = find;
    };

})(jQuery, Modernizr);
